import React, { useState } from 'react';
import '../styles/LoginPage.css';
import cost_design from "../assets/svg/cost_design_logo.svg";
import cost_design_icon from "../assets/svg/cost_design_icon.svg";
import Captcha from './Captcha';
import { ToastContainer, toast } from "react-toastify";
import computer_icon from "../assets/svg/computer-icon.png"
import { BASE_URL } from '../config';
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../hooks/PermissionContext';

import lentera from "../assets/svg/lentera-icon.svg";

const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";

const LoginPage = () => {
  const { setPermissions } = usePermissions();

  const [captcha, setCaptcha] = useState('');
  const [input, setInput] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({
    email: '',
    password: ''
  })



  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ email: '', password: '' });

    let hasError = false;
    const newErrors = { email: '', password: '' };

    if (!email.trim()) {
      newErrors.email = 'Please enter the email';
      hasError = true;
    }

    if (!password.trim()) {
      newErrors.password = 'Please enter the password';
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    if (input.toUpperCase() !== captcha) {
      toast.error('Invalid captcha');
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: isHttpsOnly ? 'include' : 'same-origin',
        body: JSON.stringify({ email, password, remember_me: rememberMe })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      console.log("Login Datas", data);
      console.log("Bearer Token", data.details.token);

      if (!isHttpsOnly) {
        localStorage.setItem("token", data.details.token);
      } else {
        localStorage.removeItem("token");
      }
      localStorage.setItem("user", JSON.stringify(data.details || {}));
      localStorage.setItem("user_type", data.details.user_type);
      localStorage.setItem("permissions", JSON.stringify(data.details.permissions)); // ✅ add this
      setPermissions(data.details.permissions || []);



      toast.success('Login Successfully');
      navigate("/jobs");
    } catch (error) {
      toast.error(error.message);
    }
  };


  return (
    <>
      <div className="login-page">
        <div className="left-panel">
          <div className="logo">
            <img src={cost_design_icon} alt='' className='cost-design-icon' />
            <span>WBS</span>
          </div>

          <h2>PRECISION WAREHOUSE BILLING MADE <br />SIMPLE “</h2>
          <div className="laptop-container">
            <img src={computer_icon} alt="Laptop Hand" className="laptop-image" />
            <div className="laptop-shadow"></div>
          </div>

        </div>

        <div className="right-panel">
          <h2>Welcome back !</h2>
          <p>Log into your account to get access</p>

          <form className="login-form" onSubmit={handleSubmit}>
            <label >Email Address <span style={{ color: 'red' }}>*</span></label>

            <div style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #E0E0E0",
              borderRadius: "12px",
              padding: "10px",
            }}>
              <FiMail style={{ marginRight: "10px", color: "#cbd5e1" }} />
              <input
                type="email"
                placeholder="abc@gmail.com"
                value={email}
                style={{ border: "none", outline: "none", flex: 1, background: "transparent", height: '20px' }}
                onChange={(e) => setEmail(e.target.value)}

              />
            </div>
            {errors.email && (
              <div className="error-message" style={{ color: 'red', fontSize: '12px', marginLeft: "5px" }}>
                {errors.email}
              </div>
            )}

            <label>Password <span style={{ color: 'red' }}>*</span></label>
            <div style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #E0E0E0",
              borderRadius: "12px",
              padding: "10px",

            }}>
              <FiLock style={{ marginRight: "10px", color: "#cbd5e1" }} />
              <input
                type={showPassword ? "" : "password"}    // <-- Dynamic here
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ border: "none", outline: "none", flex: 1, background: "transparent", height: '20px' }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}   // <-- Toggle password visibility
                style={{ cursor: "pointer", color: "#475569", fontWeight: "500", fontSize: "13px" }}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>

            </div>

            {errors.password && (
              <div className="error-message" style={{ color: 'red', fontSize: '12px', marginLeft: "5px" }}>
                {errors.password}
              </div>
            )}


            <div className="captcha-group">
              <Captcha onChange={setCaptcha} />
              <input
                type=""
                placeholder="Enter captcha here..."
                className="captcha-input"
                value={input}
                onChange={(e) => setInput(e.target.value)}

              />
            </div>

            <div className="options">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Remember my account
              </label>

              <span
                className="forgot-password"
                style={{ cursor: "pointer", color: "#1d4ed8" }}
                onClick={() => navigate("/forgetPassword")}
              >
                Forgot password?
              </span>
            </div>

            <button type="submit" className="sign-in-button">Sign In</button>
          </form>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
              fontSize: "12px",
              color: "#666",
              marginTop: "16px",
            }}
          >
            <span>{new Date().getFullYear()} © Powered by</span>
            <a href="https://lenteratech.com/" target="_blank" rel="noreferrer">
            <img
              src={lentera}
              alt="Lentera"
              style={{
                height: "14px",
                display: "block",
              }}
            />
            </a>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default LoginPage;
